<template>
  <div :key="key" class="animated fadeIn brief-entregas">
    <div class="subtitulo">
      <label>{{ titulo }}</label>

      <i class="fa fa-plus"
        v-if="opcionAgregarEntrega & !isCerrado"
        id="add-entrega"
        @click.prevent="agregarEntrega">
      </i>
    </div>

    <div class="entregas" v-for="(entrega, index) in entregas" :key="entrega.id">
      <!-- <div class="subtitulo">
        <label>{{ muestra.descripcion  }}</label>
      </div> -->
      <div class="meta">
        <p class="small text-muted">{{ entrega.fechaRegistro | fechaHora }} - {{ entrega.usuario }}</p>
        <!-- <p v-if="entrega.isValidado" class="small text-muted">Validado {{ entrega.fechaValidacion | fechaHora }} - {{ entrega.usuarioValidacion }}</p> -->
      </div>
      <b-form-group
        label="Link"
        :label-for="entrega.id.toString()"
        :label-cols="labelCols"
        :description="entrega.descripcion"
        horizontal>
        <b-input-group>
          <b-input-group-append 
              class="filter-search-icons" 
              @click="copyToClipboard(entrega)">
            <b-input-group-text>
              <i class="fa fa-copy"></i>
            </b-input-group-text>
          </b-input-group-append>

          <b-form-input 
            :id="entrega.id.toString()"
            :value="entrega.link"
            readonly
            type="text"/>
          
          <template v-if="isOriginales && !isCerrado">
            <b-input-group-append 
                class="filter-search-icons">
              <b-dropdown
                    variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    v-if="opcionEliminarEntrega"
                    @click="removeEntrega(entrega.id)">
                  <i class="fa fa-remove"></i>Eliminar Original</b-dropdown-item>

                <b-dropdown-item
                    v-if="!entrega.isValidado && opcionAgregarValidacionTecnica"
                    @click="validarEntrega(entrega)">
                  <i class="fa fa-check"></i>Validar Original</b-dropdown-item>
                
                <b-dropdown-divider v-if="(opcionEliminarEntrega || !entrega.isValidado && opcionAgregarValidacionTecnica)
                  && opcionSolicitudCambiosEntrega"> </b-dropdown-divider>

                <b-dropdown-item
                    v-if="opcionSolicitudCambiosEntrega"
                    @click="addSolicitudCambios(entrega)">
                  <i class="fa fa-plus"></i>Solicitud de Cambios</b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </template>

          <template v-if="!isOriginales && !isCerrado">
            <b-input-group-append 
                class="filter-search-icons">
              <b-dropdown
                  v-if="!entrega.isValidado || !entrega.tieneEspecificaciones"
                    variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    v-if="opcionEliminarEntrega"
                    @click="removeEntrega(entrega.id)">
                  <i class="fa fa-remove"></i>Eliminar Muestra</b-dropdown-item>

                <b-dropdown-item
                    v-if="!entrega.isValidado && opcionAgregarValidacionInformacion"
                    @click="validarEntrega(entrega)">
                  <i class="fa fa-check"></i>Validar Muestra</b-dropdown-item>
                
                <b-dropdown-divider v-if="!entrega.isValidado && !entrega.tieneEspecificaciones && opcionAgregarValidacionInformacion"> </b-dropdown-divider>

                <b-dropdown-item
                    v-if="!entrega.tieneEspecificaciones && opcionAgregarValidacionInformacion"
                    @click="addEspecificaciones(entrega.id)">
                  <i class="fa fa-plus"></i>Agregar Especificaciones</b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </template>

        </b-input-group>
      </b-form-group>

      <b-toast :id="'copied-toast-' + entrega.id.toString()" 
          auto-hide-delay="3000"
          variant="success" no-close-button no-title no-hover-pause>
        Enlace Copiado
      </b-toast>

      <div class="meta validacion" v-if="entrega.isValidado">
        <p class="small">Validó {{ entrega.fechaValidacion | fechaHora }} - {{ entrega.usuarioValidacion }}</p>
      </div>

      <div class="entrega-especificaciones" v-if="entrega.tieneEspecificaciones">
        <p class="especificaciones">{{ entrega.especificaciones }}</p>
      </div>

      <div class="entregas-cambios" v-if="entrega.tieneCambios">
        <div v-for="(cambio, index) in entrega.cambios" :key="cambio.id">
          <p class="titulo"><i class="fa fa-check" v-if="cambio.solucionado"></i> {{ cambio.fechaRegistro | fechaHora }} - {{ cambio.usuario }}</p>
          <p class="cambios">{{ cambio.cambios }}</p>
          <p class="small" v-if="cambio.solucionado">Solucionó {{ cambio.usuarioSolucion }} - {{ cambio.fechaSolucion | fechaHora }}</p>

          <template v-if="cambio.imagenes">

            <b-row class="galeria-imagenes">
              <b-col cols="12" md="3" v-for="imagen in cambio.imagenes" :key="imagen.id">
                <b-card no-header class="galeria-imagen">
                  <template v-if="isImagen(imagen.fileName)">
                    <b-img fluid
                      @click="consultarImagen(imagen.url)"
                      :src="imagen.url"></b-img>
                  </template>
                  <template v-if="isPDF(imagen.fileName)">
                    <div class="galeria-pdf">
                      <div @click="consultarPDF(imagen)">
                        <pdf 
                          :src="imagen.url"
                          :page="1"
                          :scale="0.8"/>
                      </div>
                    </div>
                  </template>
                  <template v-if="isWord(imagen.fileName)">
                    <div class="galeria-doc">
                      <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
                      <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                    </div>
                  </template>
                  <template v-if="isPowerPoint(imagen.fileName)">
                    <div class="galeria-doc">
                      <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
                      <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                    </div>
                  </template>
                  <template v-if="isExcel(imagen.fileName)">
                    <div class="galeria-doc">
                      <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
                      <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                    </div>
                  </template>
                  <template v-if="isOtro(imagen.fileName)">
                    <div class="galeria-doc">
                      <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
                      <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                    </div>
                  </template>
                  <div class="titulo">
                    <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </template>


          <b-dropdown
              v-if="!cambio.solucionado && opcionSolucionSolicitudCambiosEntrega && !isCerrado"
              variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>
            <b-dropdown-item
                @click="solucionarSolicitudCambios({ briefOriginalId: entrega.id, solicitudCambiosId: cambio.id })">
              <i class="fa fa-check"></i>Marcar como solucionado</b-dropdown-item>
            <b-dropdown-item
                @click="deleteSolicitudCambios({ briefOriginalId: entrega.id, solicitudCambiosId: cambio.id })">
              <i class="fa fa-remove"></i>Eliminar Solicitud</b-dropdown-item>
          </b-dropdown>

          <hr v-if="index != entrega.cambios.length - 1">
        </div>
      </div>

      <hr v-if="index != entregas.length - 1">
    </div>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>    
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'BriefMuestras',
  components: {
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal
  ],
  props: {
    isOriginales: {
      type: Boolean,
      default: false
    },
    entregas: {
      type: Array,
      default: []
    },
    isCerrado: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      key: 0,
      labelCols: 1,

      opcionAgregarEntrega: false,
      opcionEliminarEntrega: false,
      opcionAgregarValidacionInformacion: false,
      opcionAgregarValidacionTecnica: false,
      opcionSolicitudCambiosEntrega: false,
      opcionSolucionSolicitudCambiosEntrega: false,

      selectedFilename: '',
      selectedImageUrl: '',
      selectedBase64: '',
    }
  },
  computed: {
    // ...mapFields([
    //   'id',
    //   'muestras',
    // ]),
    titulo() {
      if (this.isOriginales) {
        return 'Originales';
      }

      return 'Muestras';
    },
  },  
  created() {
    this.opcionAgregarEntrega = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsAgregarEntrega'));
    this.opcionEliminarEntrega = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsEliminarEntrega'));
    this.opcionAgregarValidacionInformacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsEntregasValidacionInformacion'));
    this.opcionAgregarValidacionTecnica = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsEntregasValidacionTecnica'));
    this.opcionSolicitudCambiosEntrega = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsEntregasSolicitudCambios'));
    this.opcionSolucionSolicitudCambiosEntrega = Boolean(this.$store.getters['user/tieneAccesoModulo']('BriefsEntregasSolucionarSolicitudCambios'));
  },
  methods: {
    refresh() {
      this.key++;
    },
    // tieneEspecificaciones(entrega) {
    //   if (!this.isOriginales) {
    //     if (entrega.especificaciones) {
    //       return entrega.especificaciones.length != 0;
    //     }
    //   }
    //   return false;
    // },
    agregarEntrega() {
      this.$emit('addEntrega');
    },
    async copyToClipboard(entrega) {
      try {
        await navigator.clipboard.writeText(entrega.link);
        this.$bvToast.show(`copied-toast-${entrega.id.toString()}`);
        // console.log('Content copied to clipboard');
      } catch (err) {
        this.showErrorMsj(new Error('Esta operación no está permitida'));
        console.error('Failed to copy: ', err);
      }
    },
    validarEntrega(entrega) {
      this.$emit('validarEntrega', entrega);
    },
    removeEntrega(entregaId) {
      this.$emit('removeEntrega', entregaId);
    },
    addSolicitudCambios(entrega) {
      this.$emit('addSolicitudCambios', entrega);
    },
    deleteSolicitudCambios(params) {
      this.$emit('deleteSolicitudCambios', params);
    },
    solucionarSolicitudCambios(params) {
      this.$emit('solucionarSolicitudCambios', params);
    },
    addEspecificaciones(entregaId) {
      this.$emit('addEspecificaciones', entregaId);
    },
    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    handleDownload() {
      console.log('handle')
    },
  },
}
</script>

<style>
  .brief-entregas .entregas {
    margin-bottom: 30px;
  }
  .brief-entregas .subtitulo,
  .brief-entregas .subtitulo label,
  .brief-entregas .subtitulo button {
    display: inline-block !important;
  }

  .brief-entregas .meta p {
    padding-left: calc(8.33336%);
    margin-bottom: 5px;
  }
  .brief-entregas .meta.validacion p {
    font-style: italic;
    margin-bottom: 15px;
  }

  .brief-entregas #add-entrega {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-entregas #add-entrega:hover {
    color: #1b8eb7;
  }

  .brief-entregas .form-group input {
    text-transform: none !important;
  }

  .brief-entregas button.dropdown-toggle {
    background-color: #f0f3f5;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    padding-left: 18px;
    padding-right: 18px;
    color: rgba(92, 104, 115, 0.5) !important;
  }
  .brief-entregas button.dropdown-toggle:hover,
  .brief-entregas .entregas-cambios button.dropdown-toggle:hover {
    color: rgb(92, 104, 115) !important;
  }

  .brief-entregas hr.dropdown-divider {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .brief-entregas .entregas-cambios,
  .brief-entregas .entrega-especificaciones {
    border: 1px solid #ececec;
    margin-left: calc(8.33336%);
    padding: 15px 20px;
    max-height: 350px;
    overflow-y: auto;
  }
  .brief-entregas .entregas-cambios > div {
    position: relative;
  }
  .brief-entregas .entregas-cambios p.titulo {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  .brief-entregas .entregas-cambios p.titulo i {
    position: relative;
    top: -2px;
    margin-right: 5px;
  }
  .brief-entregas .entregas-cambios p.cambios,
  .brief-entregas .entrega-especificaciones p.especificaciones {
    color: #73818f !important;
    font-size: 12px;
    margin-bottom: 15px;
    white-space: pre-line;
  }
  .brief-entregas .entregas-cambios hr {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
  .brief-entregas .entregas-cambios .b-dropdown {
    position: absolute;
    top: 0;
    right: 5px;
  }
  .brief-entregas .entregas-cambios button.dropdown-toggle {
    background-color: transparent;
    border: none;
    padding: 0;
    /* color: #5c6873 !important; */
  }

  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-imagen .card-body {
    /* max-height: 200px !important; */
    max-height: 120px !important;
    overflow: hidden;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-pdf {
    cursor: pointer;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-doc {
    display: block;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-doc i,
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .galeria-doc label {
    margin-bottom: 20px;
  }
  .brief-entregas .entregas-cambios .galeria-imagenes .titulo p {
    font-size: 0.8em;
  }

</style>
